<template>
	<!-- <div id="GoTop" @click="GoTop()" class="hidden-xs">
    <span class="glyphicon glyphicon-chevron-up"></span>
  </div> -->
	<div v-if="!isPoster">
		<div class="suspension-operation-bar">
			<div class="item">
				<router-link to="/contactus">
					<img src="@/assets/img/operation-bar/telephone.png" />
				</router-link>
			</div>
			<div class="item" @click="open('https://wa.link/extmab')">
				<img src="@/assets/img/operation-bar/whatsapp.png" />
			</div>
			<div class="item" @click="GoTop()">
				<img src="@/assets/img/operation-bar/gotop.png" />
			</div>
		</div>
		<div class="consult hidden-xs">
			<router-link to="/contactus">
				<img src="@/assets/img/operation-bar/consult.png" style="width: 120px;" />
			</router-link>
		</div>
	</div>
</template>
<script>
	export default {
		name: "GoTop",
		data() {
			return {
				flag: false,
				isPoster: false
			};
		},
		created() {
			console.log('header');
			let that = this;
			let currentPath = window.location.hash;
			if(currentPath.indexOf("poster") > -1) {
				that.isPoster = true;
			}
		},
		methods: {
			GoTop() {
				(function smoothscroll() {
					var currentScroll =
						document.documentElement.scrollTop || document.body.scrollTop;
					if (currentScroll > 0) {
						window.requestAnimationFrame(smoothscroll);
						window.scrollTo(0, currentScroll - currentScroll / 10);
					}
				})();
			},
			open: function(url) {
				window.open(url);
			}
		}
	};
</script>
<style scoped>
	#GoTop {
		width: 50px;
		height: 50px;
		position: fixed;
		right: 20px;
		bottom: 20px;
		z-index: 99999999;
		cursor: pointer;
	}

	#GoTop>span {
		display: block;
		width: 100%;
		height: 100%;
		color: rgb(8, 162, 233);
		font-size: 30px;
	}

	.suspension-operation-bar {
		position: fixed;
		z-index: 99999999;
		cursor: pointer;
		right: 6px;
		top: 40vh;
		width: 43px;
		height: 156px;
		background: #65AAE3;
		border-radius: 49px 49px 49px 49px;
		padding: 15px 0;
	}

	.suspension-operation-bar .item {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 43px;
		height: 43px;
	}

	.suspension-operation-bar .item img {
		width: 25px;
		height: 25px;
	}
	
	.consult {
		position: fixed;
		z-index: 99999999;
		cursor: pointer;
		right: 70px;
		top: calc(40vh + 180px);
		width: 50px;
		height: 180px;
	}
</style>


// WEBPACK FOOTER //
// src/components/GoTop.vue